<template>
  <li
    :class="[
      'medal',
      { 'medal--active': active },
    ]"
  >
    <p class="medal__japanese">
      {{ product.japanese }}
    </p>

    <FlipPic
      class="medal__pic"
      :flipped="flipped"
      :recto="product.coin"
      :verso="product.back"
    />

    <p class="medal__name">
      {{ product.title }}
    </p>
  </li>
</template>

<script>
import FlipPic from '@/components/products/FlipPic.vue';

export default {
  name: 'CarousselItem',

  components: {
    FlipPic,
  },

  props: {
    product: { type: Object, required: true },
    active: { type: Boolean, default: false },
    flipped: { type: Boolean, default: false },
  },
};
</script>

<style lang="stylus" scoped>
.medal {
  position: relative;
  padding-top: 60px;
  padding-bottom: 127px;

  +desktop() {
    padding-top: 50px;
    padding-bottom: 10px;
  }
}

.medal__pic {
  transform: scale(0.75);
  transition: transform 0.5s ease-in-out;

  .medal--active & {
    transform: scale(1);
    transition: transform 0.5s ease-in-out;
    cursor: pointer;
  }
}

.medal__name {
  @extends $txt-carousel-title;

  position: relative;
  top: 120px;

  margin: 17px 0 0 0;
  opacity: 0;
  transition: opacity 0;

  +desktop() {
    position: static;
    margin-top: 22px;
  }

  .medal--active & {
    opacity: 1;
    transition: opacity 0.5s ease-in 0.25s;
  }
}

.medal__japanese {
  @extends $txt-carousel-title-japanese;
  pointer-events: none;
  position: absolute;
  z-index: -1;
  top: 0;
  left: 50%;

  color: $cl-secondary;
  white-space: nowrap;
  transform: translate(-50%, 0%);
  opacity: 0;
  transition: opacity 0;

  .medal--active & {
    opacity: 1;
    transform: translate(-50%, -10%);
    transition: opacity 0.5s ease-in 0.25s, transform 0.25s ease-in 0.25s;
  }
}
</style>
